export class GItem {
    constructor(data: GItem = null) {
        if (data != null) {
            this.description = data.description;
            this.value = data.value;
            this.category = data.category;
            this.canSelect = data.canSelect;
            this.reference = data.reference;
        }
    }
    canSelect?: boolean;
    description: string;
    value: any;
    category: any;
    reference: any;
}
